/* Skinny Genie redesign: Certifications page. Sticky scroll-spy sub-nav,
   ported from certifications-mockup.html. */

document.addEventListener('DOMContentLoaded', function(){
  var subnav = document.querySelector('.page-subnav');
  if(!subnav) return;
  var links = Array.prototype.slice.call(subnav.querySelectorAll('.page-subnav-link'));
  var sections = links.map(function(link){
    return document.getElementById(link.getAttribute('href').slice(1));
  }).filter(Boolean);

  var setActive = function(id){
    links.forEach(function(link){
      link.classList.toggle('active', link.getAttribute('href') === '#' + id);
    });
  };

  if('IntersectionObserver' in window){
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          setActive(entry.target.id);
        }
      });
    }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });
    sections.forEach(function(section){ observer.observe(section); });
  } else {
    window.addEventListener('scroll', function(){
      var scrollPos = window.scrollY + 120;
      var current = sections[0];
      sections.forEach(function(section){
        if(section.offsetTop <= scrollPos){ current = section; }
      });
      if(current){ setActive(current.id); }
    }, { passive: true });
  }

  links.forEach(function(link){
    link.addEventListener('click', function(e){
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if(target){
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - (subnav.offsetHeight + 12);
        window.scrollTo({ top: top, behavior: 'smooth' });
        setActive(target.id);
      }
    });
  });
});
